import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "option", "checkbox", "selected", "count", "empty"]

  connect() {
    this.update()
  }

  normalize(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("pt-BR")
  }

  filter() {
    const query = this.normalize(this.queryTarget.value.trim())
    let visible = 0
    this.optionTargets.forEach((option) => {
      option.hidden = !this.normalize(option.dataset.name).includes(query)
      if (!option.hidden) visible++
    })
    this.emptyTarget.hidden = visible > 0 || this.optionTargets.length === 0
    const selected = this.checkboxTargets.filter((input) => input.checked).length
    this.countTarget.textContent = `${selected} selecionado${selected === 1 ? "" : "s"} · ${visible} ${visible === 1 ? "disponível" : "disponíveis"}`
  }

  update() {
    this.selectedTarget.replaceChildren()
    this.checkboxTargets.filter((input) => input.checked).forEach((input) => {
      const name = input.closest("label").dataset.name
      const button = document.createElement("button")
      button.type = "button"
      button.className = "book-genre-remove"
      button.textContent = `${name} ×`
      button.setAttribute("aria-label", `Remover gênero ${name}`)
      button.dataset.action = "genre-picker#remove"
      button.dataset.id = input.id
      this.selectedTarget.append(button)
    })
    this.filter()
  }

  remove(event) {
    const input = this.checkboxTargets.find((checkbox) => checkbox.id === event.currentTarget.dataset.id)
    if (!input) return
    input.checked = false
    this.update()
    this.queryTarget.focus()
  }
}
